import Cookies from 'js-cookie'
import { param2Obj } from '@/utils'

const TokenKey = 'EBOOK_UNISCHOOL_API_TOKEN'
const USER_SESSION_KEY = 'EBOOK_UNISCHOOL_USER_SESSION_KEY'
const STUDENT_HSAREAD_BOOK_KEY = 'STUDENT_HSAREAD_BOOK_KEY'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function setToken(token) {
  return Cookies.set(TokenKey, token)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function getUsessionid() {
  const urlpara = param2Obj()
  if (urlpara && urlpara.ver) { // 目的是拿到微信回跳的参数信息
    return urlpara.ver.replace(/(#|\/)/g, '')
  }
  return Cookies.get(USER_SESSION_KEY)
}

export function setUsessionid(token) {
  return Cookies.set(USER_SESSION_KEY, token)
}

export function removeUsessionid() {
  return Cookies.remove(USER_SESSION_KEY)
}
function unique(arr) {
  return Array.from(new Set(arr))
}
export function getReadBook(bookid) {
  const readbooks = Cookies.get(STUDENT_HSAREAD_BOOK_KEY)
  if (!readbooks) {
    return []
  } else {
    return readbooks.split(',')
  }
}
export function addReadBook(bookid) {
  let readbooks = Cookies.get(STUDENT_HSAREAD_BOOK_KEY)
  if (!readbooks) {
    readbooks = bookid
  } else {
    readbooks = readbooks + ',' + bookid
    // 下面是去重
    let ra = readbooks.split(',')
    ra = unique(ra)
    let newcookies = ''
    for (const value of ra) {
      newcookies = newcookies + ',' + value
    }
    readbooks = newcookies.substr(1)
  }
  Cookies.set(STUDENT_HSAREAD_BOOK_KEY, readbooks, { expires: 30, path: '/' })
  if (readbooks) {
    return readbooks.split(',')
  }
  return []
}



// WEBPACK FOOTER //
// ./src/api/authcookie.js